
import { Component, Prop, Vue } from "vue-property-decorator";
import NodeType from "../types/NodeType";
import ChevronRight from "./shelf/ChevronRight.vue";
import ChevronDown from "./shelf/ChevronDown.vue";

@Component({
  components: {
    Node,
    ChevronRight,
    ChevronDown,
  },
  name: "node",
})
export default class Node extends Vue {
  // exclamation means that it is required, which means it does not need to be
  // initialized with a constructor
  @Prop({ required: true }) node!: NodeType;
}
